import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import useBrief from '../hooks/useBrief';
import BriefCard from '../components/brief/BriefCard';
import BriefEditor from '../components/brief/BriefEditor';
import Button from '../components/ui/Button';
import './BriefPage.css';

export default function BriefPage() {
  const { id } = useParams();
  const { brief, loading, error, saving, saveBrief, refresh } = useBrief(id);
  const [isEditing, setIsEditing] = useState(false);

  const handleSave = async (formData) => {
    try {
      await saveBrief(formData);
      setIsEditing(false);
    } catch (err) {
      // Error is handled by the hook
    }
  };

  if (loading) {
    return (
      <div className="brief-page">
        <div className="brief-page__loading">
          <div className="brief-page__spinner" />
          <p>Loading brief...</p>
        </div>
      </div>
    );
  }

  if (error || !brief) {
    return (
      <div className="brief-page">
        <div className="brief-page__error">
          <div className="brief-page__error-icon">🔍</div>
          <h2>Brief Not Found</h2>
          <p>We couldn't find a brief with that ID. It may have been deleted or the link is incorrect.</p>
          <Link to="/">
            <Button variant="primary">Create a New Brief</Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="brief-page">
      <header className="brief-page__header">
        <Link to="/" className="brief-page__logo">
          <svg viewBox="0 0 100 100" className="brief-page__logo-icon">
            <defs>
              <linearGradient id="briefVibeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#818cf8' }} />
                <stop offset="50%" style={{ stopColor: '#c084fc' }} />
                <stop offset="100%" style={{ stopColor: '#f472b6' }} />
              </linearGradient>
            </defs>
            <rect width="100" height="100" rx="20" fill="currentColor" className="brief-page__logo-bg" />
            <path 
              d="M25 70 L40 30 L50 55 L60 30 L75 70" 
              stroke="url(#briefVibeGrad)" 
              strokeWidth="8" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              fill="none"
            />
            <circle cx="50" cy="75" r="6" fill="url(#briefVibeGrad)" />
          </svg>
          <span className="brief-page__logo-text">Vibe Link</span>
        </Link>
        <Link to="/" className="brief-page__back">
          ← Create New
        </Link>
      </header>

      <main className="brief-page__main">
        {isEditing ? (
          <BriefEditor
            brief={brief}
            onSave={handleSave}
            onCancel={() => setIsEditing(false)}
            saving={saving}
          />
        ) : (
          <BriefCard
            brief={brief}
            onEdit={() => setIsEditing(true)}
          />
        )}
      </main>

      <footer className="brief-page__footer">
        <p>Share this brief by copying the URL</p>
        <a href="https://elmar.eu.org/" target="_blank" rel="noopener noreferrer" className="brief-page__footer-link">
          elmar.eu.org
        </a>
      </footer>
    </div>
  );
}
